import { MutableRefObject } from 'react';
import { ButtonProps } from 'app/components/Button';
import { IconVariants } from 'app/components/Icon';
import Quote from 'app/api/Quote';
import Correspondence from 'app/api/Correspondence';

declare global {
    interface Window {
        insurerId: number;
        brands: any[];
    }
}

export enum BrandName {
    cus = 'cus',
    bzi = 'bzi',
    asi = 'asi',
}

export enum AuthCheckStatus {
    OK = 'ok',
    SOON = 'soon',
    EXPIRED = 'expired',
    REFRESHING = 'refreshing',
}

export enum LoadingStatus {
    LOADING = 'loading',
    LOADED = 'loaded',
    ERROR = 'error',
}

export enum TableValueTypes {
    PRODUCT = 'product',
    TEXT = 'text',
    HTML = 'html',
    NUMBER = 'number',
    ICON = 'icon',
    LOADING = 'loading',
    LOZENGE = 'lozenge',
    ACTIONS = 'actions',
    BUTTON = 'button',
    SELECT_LIST = 'selectlist',
    ASSIGN_TO = 'assignto',
    ACTIVE_STATUS = 'activestatus',
    TOGGLE = 'toggle',
}

export enum TableStyleTypes {
    MAIN = 'main',
    MINIMAL = 'minimal',
    REGULAR = 'regular',
}

export enum ProductTypes {
    HOME = 'Home',
    HOME_SCTP = 'Home (SCTP)',
    LANDLORD = 'LandLord',
    LANDLORD_SCTP = 'LandLord (SCTP)',
    MOTOR = 'Motor',
    MOTOR_SCTP = 'Motor (SCTP)',
    COMMERCIAL_MOTOR = 'Commercial Motor',
    COMMERCIAL_MOTOR_SCTP = 'Commercial Motor (SCTP)',
    FARM_PACK = 'Farm Pack',
    FARM_INSURANCE = 'Farm Insurance',
    CYBER = 'Cyber',
    SMALL_MEDIUM = 'Small & Medium Enterprises',
    SME = 'SME Business Insurance',
    SME_SCTP = 'SME Business Insurance (SCTP)',
    PERSONAL_ACCIDENT = 'Personal Accident',
}

export enum FilterableProductTypes {
    MOTOR = 'Motor',
    HOME = 'Home',
    LANDLORD = 'LandLord',
    COMMERCIAL_MOTOR = 'Commercial Motor',
    CYBER = 'Cyber',
    SME = 'SME',
    FARM_PACK = 'Farm Pack',
    FARM_INSURANCE = 'Farm Insurance',
    PERSONAL_ACCIDENT = 'Personal Accident',
}

export enum ProductCodes {
    BMTR = "BMTR",
    BHME = "BHME",
    BLDL = "BLDL",
    BCMV = "BCMV",
    BCBR = "BCBR",
    SMEI = "SMEI",
    PPAC = "PPAC",
    MOTR = "MOTR",
    LNDL = "LNDL",
    HOME = "HOME",
    CMTR = "CMTR",
    SSME = "SSME",
    FARM = "FARM",
}

export enum BusinessTypes {
    NEW_BUSINESS = 'NewBusiness',
    ENDORSEMENT = 'Endorsement',
    CANCELLATION = 'Cancellation',
    RENEWAL = 'Renewal',
    POLICYTRANSFER = 'PolicyTransfer',
    REINSTATEMENT = 'Reinstatement',
    ROLLBACK = 'Rollback',
}

export enum BusinessTypeIds {
    NEW_BUSINESS = 1,
    ENDORSEMENT = 2,
    CANCELLATION = 3,
    RENEWAL = 4,
    POLICYTRANSFER = 5,
    REINSTATEMENT = 6,
    ROLLBACK = 7
}

export enum StatusTypes {
    ASSIGNED = 'Assigned',
    ACTIONED = 'Actioned',
}

export enum PolicyStatusTypes {
    BOUND = 'Bound',
    QUOTE = 'Quote',
}

export enum ActiveStatusTypes {
    ACTIVE = 'Active',
    INACTIVE = 'Inactive',
    DRAFT = 'Draft',
}

export enum StaffStatusTypes {
    ACTIVE = 'Active',
    INACTIVE = 'Inactive'
}

export enum  RenewalHoldIndicator {
    ON_HOLD = 'OnHold',
    NOT_ON_HOLD = 'NotOnHold',
}

export enum RenewalActionTypes {
    RELEASE = 'Release',
    UNRELEASE = 'Unrelease',
}

export enum RenewalActionProcessTypes {
    RELEASE = 'Release',
    UNRELEASE = 'Unrelease',
    REPLAY = 'Replay',
}

export enum RenewalReleaseStatusTypes {
    RELEASED = 'Released',
    UNRELEASED = 'Unreleased',
    NONE = 'None',
}

export enum QuoteStatusTypes {
    QUOTED = 'Quoted',
    TOBEREFERRED = 'ToBeReferred',
    REFERRED = 'Referred',
    DISCARD = 'Discard',
    DROPPED = 'Dropped',
    BIND = 'Bind',
    DECLINED = 'Declined',
    DRAFT = 'Draft',
    CONDITIONALQUOTE = 'ConditionalQuote'
}

export enum QuoteAssignTypes {
    UNDERWRITER = 'underwriter',
    REVIEWER = 'reviewer'
}

export enum TransactionStatusTypes {
    REFERRED = 'Referred',
    TOBEREFERRED = 'ToBeReferred',
    DROPPED = 'Dropped',
    DISCARD = 'Discard',
    DECLINED = 'Declined',
    RETURNED = 'ReferralReturn',
    REQUIRED = 'ReferralRequired',
    SUMMARY = 'Summary',
    QUOTED = 'Quoted',
    BIND = 'Bind',
    DRAFT = 'Draft',
    CONDITIONALQUOTE = 'ConditionalQuote'
}

export enum PolicyCancellationTypes {
    INSUREDREQUEST = 'InsuredRequest',
    PROCESSINGERROR = 'ProcessingError',
    PREMIUMNOTPAID = 'PremiumNotPaid',
    TOTALLOSS = 'TotalLoss',
    UNPAIDAUTOCANCELLATION = 'UnpaidAutoCancellation',
    PARTIALPAIDAUTOCANCELLATION = 'PartialPaidAutoCancellation'
}

export enum UserRoles {
    UnderwriterBluepoint = "UnderwriterBluepoint",
    UnderwriterCommercial = "UnderwriterCommercial",
    UnderwriterDomestic = "UnderwriterDomestic",
    UnderwriterCyber = "UnderwriterCyber",
    UnderwriterFarm = "UnderwriterFarm",
    Underwriter = 'Underwriter',
    FinanceAdmin = 'FinanceAdmin',
    SystemAdmin = 'SystemAdmin',
    Claims = 'Claims',
    ClaimsYoui = 'ClaimsYoui',
}

export enum BLUserRoleIds {
    Broker = 1,
    Underwriter = 2,
    ClaimAdmin = 3,
    FinancialAdmin = 4,
	SuperAdmin = 5,
	OrgAdmin = 6,
	SuperBroker = 7,
	SuperReader = 8,
	Support = 9,
	ClaimsBroker = 10,
}

export enum UserRolesASI {
    Underwriter = 'Underwriter',
    FinanceAdmin = 'FinanceAdmin',
    SystemAdmin = 'SystemAdmin',
    Claims = 'Claims',
}

export enum UserRolesCUS {
    Underwriter = 'Underwriter',
    FinanceAdmin = 'FinanceAdmin',
    SystemAdmin = 'SystemAdmin',
    Claims = 'Claims',
}

export enum UnderwriterCorrespondenceTypes {
    COMMENT = 'Comment',
    NOTE = 'Note',
}

export enum UnderwriterActionTypes {
    QUOTE = 'Quote',
    DECLINED = 'Declined',
    RETURNED = 'ReferralReturn'
}

export enum PrepopulatedUnderwriterActionTypes {
    QUOTE = 'Quoted',
}

export enum QuoteAllocationTypes {
    ALL = 'all',
    PENDING = 'pending',
    RENEWAL = 'renewal',
    ASSIGNED = 'assigned',
    IN_PROGRESS = 'in-progress',
    ESCALATED = 'escalated',
    ACTIONED = 'actioned',
    CURRENT = 'current',
}

export enum RiskPanelSectionTypes {
    HEADING = 'Heading',
    CARD = 'Card',
    TABLE = 'Table',
    QUESTION = 'Question',
    TITLE = 'Title',
    ACCORDION = 'Accordion',
}

export enum QuoteRouteDetailTypes {
    HOME = 'home',
    PREMIUM = 'premium',
    CONDITIONS = 'conditions',
    RISK = 'risk',
    DOCUMENTS_CLAIMS = 'documents_claims',
    RENEWAL_LOGS = 'renewal_logs',
    CHANGELOG = 'changelog',
}

export enum TransactionAllocationTypes {
    UNRECONCILED = 'unreconciled',
    RECONCILED = 'reconciled',
    NONE = 'none',
}

export enum MatchType {
    ALL = 'All',
    MANUAL = 'Manual',
    MATCHED_OFF_SYSTEM = 'MatchedOffSystem',
    AUTOMATCH = 'Automatch',
}

export enum MatchCategory {
    PARKED = 'Parked',
    MATCHED = 'Matched',
    COMBO_MATCHED = 'ComboMatched',
    UNMATCHED = 'Unmatched',
    PARTIALPAYMENT = 'PartialPayment',
    OVER_PAYMENT = 'OverPayment',
}

export enum StatementStatus {
    ALL = 'All',
    MATCHED = 'Matched',
    UNMATCHED = 'Unmatched',
}

export enum StatementSort {
    NEWEST = 'Newest',
    OLDEST = 'Oldest',
}

export enum RemittanceSort {
    NEWEST = 'Newest',
    OLDEST = 'Oldest',
}

export enum RemittanceStatus {
    ALL = 'All',
    MATCHED = 'Matched',
    UNMATCHED = 'Unmatched',
}


export enum RemittanceMessageAction {
    IncorrectFunds = 'IncorrectFunds',
    UnmatchedFunds = 'UnmatchedFunds',
}

export enum EmailStatus {
    ALL = 'All',
    SUCCESS = 'Success',
    FAILED = 'Failed',
    TOTALS_NOT_MATCH = 'TotalsNotMatched',
    MANUALLY_REVIEWED = 'ManuallyReviewed',
}

export enum RemittanceLineStatus {
    ALL = 'All',
    MATCHED = 'Matched',
    COMBO_MATCHED = 'ComboMatched',
    UNMATCHED = 'Unmatched',
    PARTIAL_PAYMENT = 'PartialPayment',
    OVER_PAYMENT = 'OverPayment',
    PARKED = 'Parked',
    NET_ZERO = 'NetZero'
}

export enum RemittanceStage {
    NOTACTIONED = 'NotActioned',
    EMAILED = 'Emailed',
    AWAITING_FUNDS = 'AwaitingFunds',
    ISSUE = 'Issue',
    AWAITING_TAKE_BACK = 'AwaitingTakeBack',
    SECOND_EMAIL = 'SecondEmail',
    NP_CANCELLATION = 'NPCancellation',
    FINAL_EMAIL = 'FinalEmail',
    WITH_RM = 'WithRM',
    REVIEW = 'Review',
}

export enum StatementStage {
    NOTACTIONED = 'NotActioned',
    EMAILED = 'Emailed',
    AWAITING_REMITTANCE = 'AwaitingRemittance',
    ISSUE = 'Issue',
    AWAITING_TAKE_BACK = 'AwaitingTakeBack',
    SECOND_EMAIL = 'SecondEmail',
    NP_CANCELLATION = 'NPCancellation',
    FINAL_EMAIL = 'FinalEmail',
    WITH_RM = 'WithRM',
    REVIEW = 'Review',
    REFUND = 'Refund',
    PARKED = 'Parked',
    RUN_OFF_PAYMENT = 'RunOffPayment',
    GOVT_CHARGE = 'GovtCharge',
    UW_PAYMENT = 'UWPayment',
    CLAIMS_RECOVER = 'ClaimRecover'
}

export enum RemittanceStageSelectList {
    ALL = 'All',
    NOTACTIONED = 'NotActioned',
    AWAITING_FUNDS = 'AwaitingFunds',
    AWAITING_TAKE_BACK = 'AwaitingTakeBack',
    EMAILED = 'Emailed',
    FINAL_EMAIL = 'FinalEmail',
    ISSUE = 'Issue',
    NP_CANCELLATION = 'NPCancellation',
    REVIEW = 'Review',
    SECOND_EMAIL = 'SecondEmail',
    WITH_RM = 'WithRM'
}

export enum StatementStageSelectList {
    ALL = 'All',
    NOTACTIONED = 'NotActioned',
    EMAILED = 'Emailed',
    AWAITING_REMITTANCE = 'AwaitingRemittance',
    ISSUE = 'Issue',
    REFUND = 'Refund',
    PARKED = 'Parked',
    RUN_OFF_PAYMENT = 'RunOffPayment',
    GOVT_CHARGE = 'GovtCharge',
    UW_PAYMENT = 'UWPayment',
    CLAIMS_RECOVER = 'ClaimRecover'
}

export enum RemittanceStageFormList {
    NOTACTIONED = 'NotActioned',
    EMAILED = 'Emailed',
    AWAITING_FUNDS = 'AwaitingFunds',
    ISSUE = 'Issue'
}

export enum RemittanceLineStageFormList {
    NOTACTIONED = 'NotActioned',
    EMAILED = 'Emailed',
    AWAITING_FUNDS = 'AwaitingFunds',
    ISSUE = 'Issue',
    AWAITING_TAKE_BACK = 'AwaitingTakeBack',
    SECOND_EMAIL = 'SecondEmail',
    NP_CANCELLATION = 'NPCancellation',
    FINAL_EMAIL = 'FinalEmail',
    WITH_RM = 'WithRM',
    REVIEW = 'Review',
}

export enum StatementStageFormList {
    NOTACTIONED = 'NotActioned',
    EMAILED = 'Emailed',
    AWAITING_REMITTANCE = 'AwaitingRemittance',
    ISSUE = 'Issue',
    REFUND = 'Refund',
    PARKED = 'Parked',
    RUN_OFF_PAYMENT = 'RunOffPayment',
    GOVT_CHARGE = 'GovtCharge',
    UW_PAYMENT = 'UWPayment',
    CLAIMS_RECOVER = 'ClaimRecover'
}

export enum RemittanceLineSort {
    ASCENDING = 'Ascending',
    DESCENDING = 'Descending',
}

export enum RemittanceLineBankMatch {
    All = 'All',
    MATCH = 'Match',
}

export enum CompareDiffTypes {
    REMOVED = 'Removed',
    NEW = 'New',
    MODIFY = 'Modify',
}

export enum MatchedStatus {
    MATCHED = 'Matched',
    UNMATCHED = 'Unmatched',
    PARTIALLY_MATCHED = 'PartiallyMatched',
    NO_MATCHING_REMITTANCE = 'NoMatchingRemittance',
    NO_MATCHING_PAYMENT = 'NoMatchingPayment',
}

export enum ExtractStatus {
    SUCCESS = 'Success',
    FAILED = 'Failed',
}

export enum TransactionType {
    BANK_TRANSACTION = 'BankTransaction',
    REMITTANCE = 'Remittance',
}

export enum CorrespondenceType {
    BROKER = 'broker',
    INTERNAL = 'internal',
    UNDERWRITER = 'underwriter',
    REMITTANCE = 'remittance',
    REMITTANCE_LINE = 'remittance_line',
    BANK_STATEMENT_LINE = 'bank_statement_line',
}

export enum QuoteDocumentType {
    QUOTE = 'quote',
    POLICY = 'policy',
}

export enum DocumentVersion {
    NEW = 'new',
    LEGACY = 'legacy',
}

export enum FileUploadType {
    BROKER = 'broker',
    UNDERWRITER = 'underwriter',
    REMITTANCE_FILE = 'remittance_file',
    REMITTANCE_CSV = 'remittance_csv',
    BANK_STATEMENT = 'bankstatment',
    BULK_POLICY_UPDATE_CSV = 'bulkpolicyupdatecsv',
    WELCOME_EMAIL_CSV = 'welcomeemailcsv',
    CLAIMS_REPORT = 'claims_report',
    BULK_RENEWAL_ACTION = 'bulkrenewalaction',
}

export enum PolicyPaymentStatus {
    UNPAID = 'Unpaid',
    PAID = 'Paid',
    APPROVED = 'Approved',
}

export enum PremiumViewType {
    TERM = 'term',
    CHANGE = 'change',
}

export enum PremiumAdjustmentType {
    PREMIUM = 'premium',
    AGENCY = 'agency',
    UNDERWRITER = 'underwriter',
}

export enum QuoteConditionType {
    RISK = 'Risk',
    POLICY = 'Policy',
}

export enum PaymentFrequencyType {
    MONTHLY = 'Monthly',
    ANNUALLY = 'Annually',
}

export enum SettlementCodes {
    FullyPaidAnnual = "FPY1", 
    PartialPaymentAnnual = "PPY2",
    OverPaymentUnbound = "OPY4",
    ReturnedRemittanceIncorrectPayment = "RRM1",
    OverPaymentAnnual = "OVPY",
    InstalmentPaymentMonthly = "IPY3",
    FullyPaid = "PAID",
    WriteOff = "WFP1",
    WriteOn = "WNP2",
    ReverseFullPaid = " RFP",
}

export enum ConditionCode {
    MANUAL = 'Manual',
    DECLINED = 'Declined',
    MOREINFO = 'MoreInfo'
}

export enum StageSubjectType {
    RemittanceLine = 'RemittanceLine',
    Remittance = 'Remittance',
    BankStatementLine = 'BankStatementLine'
}

export interface PaginationCriteria {
    pageSize?: number;
    pageNumber?: number;
}

export interface MatchPolicyAdjustment {
    value: number;
    allowOverride: boolean;
}

export interface MatchPolicyCalculatedTotals {
    calculatedTotal: number;
    adjustmentsTotal: number;
    difference: number;
}

export interface QuoteRouteParamsType {
    transactionId: string;
    compareId?: string;
    risk?: string;
    detail?: string;
    uid?: string;
    subUid?: string;
}

export interface RemittanceSummary {
    remittanceId: string;
    remittanceName: string;
    createdDate?: Date;
    stage: RemittanceStage;
    status: MatchCategory;
    lineCount: number;
    unmatchedLineCount: number;
    total: number;
    correspondence: Correspondence[];
}

export interface RemittanceComment {
    Template: string;
    RemittanceLinesCount: number;
    RemittanceLinesTotal: number;
    RemittanceTotal: number;
    TotalsMatched: boolean;
}

export interface RemittanceUploadSummary {
    remittanceLinesCount: number;
    remittanceLinesTotal: number;
    remittanceTotal: number;
    template: string;
    totalsMatched: boolean;
}

export interface UpdateRemittancePostData {
    RemittanceId: string;
    Total?: number;
    Stage?: RemittanceStage;
    DistributionOrganisationId?: number;
}

export interface RemittanceRouteParamsType {
    remittanceId: string;
    remittanceLineId?: string;
}

export interface ActionOption {
    label: string;
    action: () => void;
    disabled: boolean;
}

export interface OptionValue {
    label: string;
    value: any;
}

export interface TableGroupHeaderGroupType {
    length: number;
    group: string;
    color: string;
}

export interface TableHeaderItem {
    type: TableValueTypes;
    title: string;
    link?: boolean;
    iconColor?: string;
    currency?: boolean;
    date?: boolean;
    percentage?: boolean;
    columnDisabled?: boolean;
    disabled?: boolean;
    round?: boolean;
    editable?: boolean;
    external?: boolean;
    highlight?: string;
    border?: string;
    align?: string;
    errorMessage?: string;
    buttonParams?: ButtonProps;
    options?: OptionValue[];
    hoverDecoration?: string;
    hoverColor?: string;
    sticky?: boolean;
    collapsable?: boolean;
    textWrap?: boolean;
    group?: string;
    groupColor?: string;
    buttonText?: string;
    buttonColumns?: number;
    tabLevel?: number;
    size?: string;
}

export interface TableDataRow {
    row: any[];
    selected?: boolean;
    highlight?: 'color' | 'bold' | 'boldColor' | 'greyColor' | 'compare' | 'disabled';
    border?: 'top' | 'bottom';
    ref?: MutableRefObject<any>;
    footer?: boolean;
    parentIndex?: number;
    rowIndex?: number;
    selectable?: boolean | 'hide';
}

export interface TableActionItem {
    icon: string;
    label: string;
    conditionIndex?: number;
    conditionValue?: any;
    conditionType?: any;
}

export interface TableData {
    headers: TableHeaderItem[];
    content?: TableDataRow[];
    actions?: TableActionItem[];
}

export interface ToggleValue {
    label: string;
    value: string | number;
}

export interface SearchDatePeriod {
    start: string;
    end: string;
}

export interface QuoteFilterCriteria {
    DistributionBranchId?: string;
    DistributionOrganisationId?: string;
    PartialQuoteNumber?: string;
    DatePeriod?: SearchDatePeriod;
    Product?: ProductTypes;
    TransactionTypeId?: BusinessTypes;
    Status?: StatusTypes;
    Org?: string;
    Branch?: string;
    SortCriteria?: 'referralAgeAsc' | 'referralAgeDesc';
    Underwriter?: string;
    Reviewer?: string;
    Stage?: QuoteStatusTypes;
}

export interface QuoteSearchResponse {
    Data: QuoteSearchResponseItem[],
    DataCount: number
}

export interface QuoteSearchResponseItem {
    Document: QuoteSearchResponseDocument,
    Highlights: SearchHighlightData
}


export type QuoteSearchResolution = {
    quotes: Quote[],
    pageCount?: number
}

export interface QuoteSearchResponseDocument {
    Content: {
        TransactionDetailsSearch: {
            TransactionId: number
            ExternalReference: string
            TransactionType: string
            QuoteStatus: string
            StartDate: string
            EffectiveDate: string
            ExpirationDate: string
            RenewalCounter: number
            ProductCode: string
            InsurerId: number
            DistributionBranchId: number
            RatingDate: string
            QuoteCreationDate: string
            Product: string
            InsurerCode: string
            UserId: number
            UserEmail: string
            UserName: string
        },
        Parties: {
            Name: string
        }[]
    }
}

export interface SearchHighlightData {
    [key: string]: string[]
}

export interface SearchHighlight {
    label: string;
    value: string;
}

export interface RenewalSearchCriteria {
    pageNumber?: number;
    pageSize?: number;
    ascending: boolean;
    effectiveDateFrom: string;
    effectiveDateTo: string;
    productCode?: string;
    transactionStatus?: string;
    underwriter?: number;
}

export interface RenewalData {
    PolicyNumber: string,
    QuoteNumber: string,
    TransactionId: number,
    LastBoundTransactionId: number,
    BoundTransactionId: number,
    TransactionStatus: TransactionStatusTypes,
    StartDate: string,
    HoldIndicator: number,
    RenewalCounter: number,
    ProductCode: BusinessTypes,
    Underwriter?: number,
    Reviewer?: number,
    AssignmentComment?: string,
    Branch?: string;
    HoldReason?: string;
}

export interface RemittanceLineSearchCriteria {
    pageNumber?: number;
    pageSize?: number;
    ascending?: boolean;
    searchText?: string;
    matchedStatus?: RemittanceLineStatus | '';
    stage?: RemittanceStage | '';
    amount?: number | '';
    absolute?: boolean;
}

export interface RemittanceLineSearchInputCriteria {
    search?: string;
    status?: RemittanceLineStatus;
    stage?: RemittanceStage;
    amount?: string;
    abs?: 'true' | 'false';
    match?: RemittanceLineBankMatch;
    sort?: RemittanceLineSort;
}

export interface RemittanceLineIncorrectFundsLineMeta {
    RemittanceId: string;
    RemittanceLineId: string;
    PolicyNumber: string;
    InsuredName: string;
    Status: string;
    InceptionDateString: string;
    TransactionId: number;
    AmountPaid: number;
    OutstandingAmount: number;
    TotalAmount: number;
    PolicyInsuredName: string;
    Commission: number;
}

export interface RemittanceLineIncorrectFundsMeta {
    ToList: string[],
    CcList: string[],
    DynamicTemplateData: {
        RemittanceId: string,
        Data: {
            RemittanceLineDetails: RemittanceLineIncorrectFundsLineMeta[]
        },
        Comment?: string;
    },
    Stage?: RemittanceStage;
}

export interface RemittanceLineUnmatchedFundsMeta {
    ToList: string[],
    CcList: string[],
    RemittanceLineIds: string[],
    Comment: string;
    Stage: RemittanceStage;
}

export interface RemittanceLineData {
    RemittanceLineId: string;
    RemittanceId: string;
    MatchedStatus: MatchCategory;
    Stage: RemittanceStage;
    Amount: number;
    PolicyNumber: string;
    InsuredName: string;
    BrokerInvoiceReference: string;
    EffectiveDate: string;
    InceptionDate: string;
    TransactionType: BusinessTypes;
    CreatedDateTime: string;
    Comments: {
        Email: string;
        Comment: string;
        CreatedDateTime: string;
    }[];
}

export interface EditRemittanceLineData {
    Amount: number;
    PolicyNumber?: string;
    InsuredName?: string;
    BrokerInvoiceReference?: string;
    EffectiveDate?: string;
    TransactionType?: BusinessTypes;
    Stage?: RemittanceStage;
    RemittanceId?: string;
    RemittanceLineId?: string;
}

export interface RemittancesSearchInputCriteria {
    pageNumber?: number;
    pageSize?: number;
    remittanceName?: string;
    status?: RemittanceStatus;
    stage?: RemittanceStageSelectList;
    amount?: string;
    sort?: RemittanceSort;
}

export interface EmailActivityInputCriteria {
    subject?: string;
    status?: EmailStatus;
    amount?: string;
}

export interface EmailActivitySearchCriteria {
    pageNumber?: number;
    pageSize?: number;
    subject?: string;
    status?: EmailStatus | '';
    amount?: number | '';
}

export interface PolicySearchCriteria {
    PartialQuoteNumber?: string;
    SearchText?: string;
    Amount?: number;
    Status?: PolicyStatusTypes;
    Bound?: boolean | null;
}

export interface QuoteSearchCriteria {
    SearchText?: string;
    TransactionType?: string;
    TransactionStatus?: string;
    ProductCode?: string;
    PageNumber?: number;
    PageSize?: number;
}

export interface TransactionSearchCriteria {
    PartialBrokerOrg?: string;
    DateRange?: SearchDatePeriod;
    Matched?: boolean;
}

export interface TransactionSearchInputCriteria {
    search?: string;
    date?: {
        start?: Date;
        end?: Date;
    };
}

export interface TransactionExport {
    fileName?: string;
    content?: ArrayBuffer;
}

export interface RiskPanelHeadingData {
    Title: string;
    Description?: string;
}

export interface StatementSearchCriteria {
    PageSize?: number;
    PageNumber?: number;
    Ascending?: string;
    PartialNarrative?: string;
    MatchedStatus?: string;
    Stage?: string;
    Credit?: number | '';
}

export interface StatementSearchInputCriteria {
    search?: string;
    status?: StatementStatus;
    stage?: RemittanceStageSelectList;
    amount?: string;
    sort?: string;
}

export interface ResetPoliciesParams {
    policyNumber: string;
    renewalCounter: number;
    invoiceIds?: string[];
}

export interface RiskPanelTableFormat {
    ColumnName: string;
    DataType: string;
}

export interface RiskDataPanelSection {
    Type: string;
    Format: string | RiskPanelTableFormat[] | null;
    Data?: RiskPanelHeadingData | (string | number)[][] | string;
    UID?: string;
    StartDate?: Date;
    EffectiveDate?: Date;
    ExpirationDate?: Date;
    Sections: RiskDataPanelSection[] | RiskDataPanelSection[][];
    DeletionReason?: string;
    DeletionReasonDescription?: string;
    Diff?: CompareDiffTypes;
}

export interface RiskMetaProps {
    copyUID?: string;
    startDate?: Date;
    effectiveDate?: Date;
    expirationDate?: Date;
    deletionReason?: string;
    deletionReasonDescription?: string;
}

export interface RiskDataPanel {
    Title: string;
    UID: string | null;
    Sections: RiskDataPanelSection[];
    Collapsed?: boolean;
    Changed?: boolean;
    CollectionPath?: string;
    Diff?: CompareDiffTypes;
}

export interface RiskDataSection {
    TabTitle: string;
    Panels: RiskDataPanel[];
}

export interface UserSearchCriteria {
    Email?: string;
    FirstName?: string;
    LastName?: string;
    Initials?: string;
    Position?: StatusTypes;
    Roles?: UserRoles[];
    Status?: boolean;
}

// Quote
export interface QuoteUser {
    userId: number;
    initials: string;
    abbreviation?: string;
    email: string;
}

export interface QuoteRiskOverview {
    name: string;
    slug: string;
    alert: boolean;
    changed?: boolean;
}

export interface QuoteReferralReason {
    uid: number;
    ruleCode: string;
    message: string;
    createdDate: Date;
    decision: string;
    decisionCode: string;
}

export interface UserBranch {
    distributionBrokerBranchId: number;
    distributionOrganisationId: number;
    distributionBrokerBranchName: number;
}

export interface UserRolePostData {
    Service: string;
    Level: number;
}

export interface UserPhonePostData {
    Type: string;
    Number: string;
}

export interface SelectListOption {
    value: number | string;
    label: string;
    disableRemove?: boolean;
}

export interface UserPostData {
    Id?: number;
    UserId?: number;
    Email: string;
    FirstName: string;
    LastName: string;
    Initials: string;
    Position: string;
    PortraitId?: string;
    Roles: UserRolePostData[];
    Active: boolean;
    PhoneNumbers: UserPhonePostData[];
}

export interface QuotePremiumData {
    label?: string;
    changeData: QuotePremiumLine[];
    termData: QuotePremiumLine[];
    changeTotal?: QuotePremiumLine;
    termTotal?: QuotePremiumLine;
}

export interface QuotePremiumLine {
    uid?: string;
    title?: string;
    typeTitle?: string;
    riskPremium: number;
    preTaxPremium: number;
    postTaxPremium: number;
    commission: number;
    GST?: number;
    commissionGST?: number;
    stampDuty?: number;
    insurerFee?: number;
    insurerFeeGST?: number;
    brokerFee?: number;
    brokerFeeGST?: number;
    discount?: number;
    premiumRoadsideAssistance?: number;
    premiumRoadsideAssistanceGst?: number;
    totalDue?: number;
}

export interface QuotePremiumAdjustment {
    value: number | string;
    factor: number | string;
    agency: number | string;
}

export interface QuotePremiumAdjustmentDisplay {
    value: string;
    factor: string;
    agency: string;
}

export interface QuotePremiumFinanceCreditCard {
    cardNumber: string;
    cardType: string;
    cardExpiry: string;
}

export interface QuotePremiumFinanceBank {
    accountBsb?: string;
    accountNumber?: string;
}

export interface QuotePremiumFinanceSchedule {
    paymentDate: Date;
    paymentAmount: number;
    paymentStatus?: string;
}

export interface QuotePremiumFinance {
    effectiveDate?: Date;
    expirationDate?: Date;
    nextPaymentDueDate?: Date;
    paymentDetailsCC?: QuotePremiumFinanceCreditCard;
    paymentDetailsBank?: QuotePremiumFinanceBank;
    paymentSchedules: QuotePremiumFinanceSchedule[];
    cancelationReason?: string;
}

export interface PolicyPaymentDetail {
    BoundTransactionId: number;
    TransactionTypeId: number;
    ProcessedDate?: Date;
    EffectiveDate?: Date;
    PaymentFrequency?: string;
    SettlementAmount?: number;
    Invoices?: PolicyPaymentInvoice[];
}

export interface SettlementDetails {
    SettlementId?: number;
    SettlementDate?: Date;
    SettlementAmount?: number;
    SettlementType?: string;
    SettlementCode?: SettlementCodes;
    PaymentCurrentStatus?: string;
    SettlementReference?: {
        RemittanceLineId?: string;
        PaymentGatewayDetailId?: string;
    }
}

export interface PolicyPaymentInvoice {
    FullyPaid?: boolean;
    InvoiceId?: number;
    InvoiceNumber?: string;
    TotalAmount?: number;
    SettlementAmount?: number;
    PaymentDetails?: PolicyPaymentPaymentDetails;
    SettlementDetails?: SettlementDetails[];
}

export interface PolicyPaymentPaymentDetails {
    ScheduleDate?: Date;
    amountDue?: number;
    amountOutstanding?: number;
}

export interface QuoteRiskDecisionReason {
    ruleCode: string;
    value: string;
    message: string;
    decisionCode: string;
    underwriterDecision: string;
    isCurrent: boolean;
}

export interface QuoteRiskDecision {
    UID: string;
    ReferenceCode: string;
    UnderwritingFactor: number;
    AdjustmentFactor: number;
    DecisionReasons: QuoteRiskDecisionReason[];
    RiskConditions: QuoteCondition[];
}

export interface QuoteRiskDecisionResponse {
    Errors?: any[] | null;
    ErrorCode?: string | null;
    Status?: boolean;
    Data?: {
        TransactionId: number;
        DateTime: string;
        ReferOnRenewal: boolean;
        ReferOnRenewalDetails: string | null;
        PolicyDecisions: any[];
        PolicyConditions: any[];
        RiskDecisions: QuoteRiskDecision[];
    };
}

export interface ConditionsQueryProps {
    conditionLevel?: string;
    productCode?: string;
}

export interface MessageTemplateQueryProps {
    actionType?: string;
    productCode?: string;
    transactionType?: string;
    messageType?: string;
    messageCode?: string;
}

export interface QuoteTransactionDetails {
    TransactionId: number;
    ProductCode: string;
    DistributionBranchId: number;
    DistributionOrganisationId: number;
    StartDate: Date | null;
    RatingDate: Date | null;
    RenewalCounter: number;
}

export interface QuoteActionPostData {
    TransactionDetails?: QuoteTransactionDetails;
    DecisionResponse: QuoteRiskDecisionResponse;
    Status?: string | null;
    UnderwriterComment?: string;
    ChangeLog: string[];
}

export interface QuotePayload {
    TransactionDetails: QuoteTransactionDetails;
    DecisionResponse: QuoteRiskDecisionResponse;
    UnderwriterId?: string;
}

export interface TransactionComparisonArray {
    id: number;
    key: string;
}

export interface TransactionComparison {
    RiskDetails?: RiskDataSection[]
}

export interface QuoteCondition {
    ShortDescription: string;
    FullDescription: string;
    DateCreated?: string;
    ConditionCode?: string | null;
    CreatedBy?: string;
    RiskUID?: string;
    ProductCode?: string;
    Deleted?: boolean;
}   

export interface ReferralOnRenewal {
    refer: boolean;
    reason: string | null;
}

export interface ReferralOnRenewalDetails {
    data: {
        referOnRenewal: boolean;
        referOnRenewalDetails: string;
    };
    dataCount: number;
    statusCode: number;
}

export interface StatsData {
    TotalOutstandingReferrals?: number;
    OutstandingReferralsOverPastDay?: number;
    ReferralsProcessedToday?: number;
    AvgOutstandingReferralAge?: number;
    OpeningBalance?: number;
    ClosingBalance?: number;
    TransactionsToReconcile?: number;
    MatchedTransactionsToReconcile?: number;
}

export interface TransactionStats {
    CountAllocatedFundsForThisWeek?: number;
    CountAllocatedRemittance?: number;
    CountlUnallocatedRemittance?: number;
    TotalAllocatedFundsForThisWeek?: number;
    TotalAllocatedRemittance?: number;
    TotalUnallocatedRemittance?: number;
}

export interface RemittanceScanMetadata {
    totalsMatched: boolean;
    totalDifference?: number;
}

export interface PolicyCancellationInformation {
    TransactionId?: number;
    QuoteNumber?: string;
    PolicyNumber?: string;
    QuoteStatus?: QuoteStatusTypes;
}

export interface GenerateRenewalResponse {
    TransactionDetails: {
        TransactionId: number
    }
}

export interface EmailBrokerFormValues {
    comment?: string;
    emailAddress?: string;
    cc?: string;
    stage?: RemittanceStage;
    remittanceLineIds?: string[];
}

export interface HoldCoverFormValues {
    note?: string;
    date?: string;
}

export interface PanelHeaderButtonProps {
    text: string;
    icon?: IconVariants;
    clickHandler?: Function;
    color?: string;
    backgroundColor?: string;
    backgroundHoverColor?: string;
    disabled?: boolean;
}

export interface TransferPolicyResultItem {
    ResponseText: string;
    StatusCode: number;
    PolicyNumber: string;
}

export interface WelcomeEmailResultItem {
    Email: string;
    EmailSent: boolean;
}

export interface BLUserData {
    FirstName?: string,
    LastName?: string,
    MiddleName?: string,
    PrimaryContactNumber?: string | null,
    Email?: string,
    AllowedBranches?: number[],
    AllowedRoles?: number[],
    SendWelcomeEmail?: boolean,
    IsActive?: boolean
}

export interface NewBLUserResult {
    CreateUserResponse: string;
    CreateUserAccessResponse: string;
    EmailSent: boolean;
}

export interface HoldCoverDetails {
    comment: string,
    defermentDate: string
}

export interface TransactionHistoryItem {
    TransactionId: number,
    TransactionTypeId: number,
    TransactionStatus: string,
    EffectiveDate: string,
    ModifiedDate: string,
    BrokerBranchName: string,
    RenewalCounter: number,
    QuoteDropped: boolean
}

export interface QuoteHistoryItem {
    transactionTypeId: number,
    transactionId: number,
    transactionStatus: string,
    createdDttm: string,
    releaseIndicator: boolean,
    quoteDropped: boolean
}

export interface ComparedQuoteMetaData {
    transactionId: number,
    boundTransactionId: number,
    quoteNumber: string,
    policyNumber: string,
    stage
    product: ProductTypes,
    transactionType: TransactionType
    transactionTypeId: number,
    transactionStatus: QuoteStatusTypes,
    channel: string,
    insured: string,
    inception: Date,
    expiry: Date,
    effectiveDate: Date,
    coverType: string,
    renewalCounter: number,
    brokerOrgId: number,
    brokerBranchId: number,
    underwriter: number,
    reviewer: number
}

export interface RenewalLog {
    createdAt: Date,
    errorCode: string,
    errorDetails: object,
    renewalAction: string
}

export interface ChangeLogLineItem {
    TransactionId: number,
    TransactionTypeId: number,
    UserEmail: string,
    CreatedDateTime: Date,
    Description: string
}

export interface RemittanceLinePaymentHistory {
    policyNumber: string
    transactionId: number
    insuredName: string
    amountPaid: number
    amountAllocated: number
    amountDue: number
    amountOutstanding: number
    adjustment: number
    status: MatchCategory
    matchDate?: Date
    matchType: MatchType
}

export interface PaymentHistoryData {
    MatchedStatus: MatchCategory
    Stage: RemittanceStage
    Amount: number
    PolicyNumber: string
    InsuredName: string
    BrokerInvoiceReference: string
    EffectiveDate: string
    TransactionType: BusinessTypes
    RemittanceLineId: string
    RemittanceId: string
    CreatedDateTime: string
    ModifiedDateTime: string
    TransactionMatchings: PaymentHistoryTransactionMatching[]
}

export interface PaymentHistoryTransactionMatching {
    InvoiceId: number
    TransactionId: number
    Difference: number
    Adjustment: number
    AmountAllocated: number
    InvoiceTotal: number
    Active: boolean
    MatchType: MatchType
    Settlements: PaymentHistorySettlement[],
    ExternalReference: string
    CreatedDateTime: string
}

export interface PaymentHistorySettlement {
    SettlementCode: SettlementCodes
    SettlementAmount: number
    SettlementReference: string
    SettlementDate: Date
    CounterPartyName: string
    SettlementId: number
}